<template>
  <input
    v-if="user.isSalesEstimator && authEstimator != undefined"
    v-model="estimatorNameProxy"
    />

  <select-input-dict
    v-else
    v-model="estimatorCode"
    :select-list="estimators"
    :options="estimators"
    label="title"
  />
</template>

<script setup lang="ts">
import { computed, defineModel, watch } from "vue";

import SelectInputDict from "@/components/UI/SelectInputDict.vue";

import { useDictStore } from "@/stores/dictStore";
import { useUserStore } from "@/stores/userStore";

const dictStore = useDictStore();
const user = useUserStore();
const isSalesEstimator = computed(() => user.isSalesEstimator);

const estimators = dictStore.getEstimators();
const authEstimator = computed(
  () => estimators.filter((item) => item.code === user.userCode)[0],
);

const estimatorCode = defineModel<string>({
  default: "",
});


const estimatorName = defineModel<string>("estimatorName", {
  default: "",
});

let initialized = false;
const estimatorNameProxy = computed({
  get() {
    if (!initialized) {
      initialized = true;
      return estimatorName.value || authEstimator.value?.title || "";
    }
    return estimatorName.value;
  },
  set(val) {
    estimatorName.value = val;
  }
});

watch(
  () => isSalesEstimator,
  () => {
    if (user.isSalesEstimator && authEstimator.value != undefined) {
      estimatorCode.value = authEstimator.value.code;
    }
  },
  { immediate: true },
);

watch(
  () => authEstimator.value?.title,
  () => {
    estimatorName.value = authEstimator.value?.title ?? "";
  },
  { immediate: true },
);

</script>

<style lang="scss" scoped></style>
